export default __webpack_public_path__ + "static/media/0329.ab20fb67.jpg";